import React from 'react';
import {
    FaMapMarkerAlt,
    FaFileContract,
    FaDraftingCompass,
    FaChartLine,
    FaHandshake,
    FaUserTie,
    FaHeadset,
    FaLeaf,
    FaCheckCircle,
    FaCreditCard,
    FaShieldAlt,
    FaHeart,
    FaBuilding,
    FaUsers
} from "react-icons/fa";
import AboutBanner from './AboutBanner';
import SisterConcerms from './SisterConcerms';

// ইমেজ ইম্পোর্ট (প্রজেক্টের ফাইল পাথ অনুযায়ী অ্যাডজাস্ট করুন)
import whyChooseImg from '../../assets/banner/banner-715.jpg';

const WhyChooseUs = () => {
    // ১. Key Advantages Data (৮টি মূল সুবিধা)
    const keyAdvantages = [
        {
            icon: <FaMapMarkerAlt size={28} className="text-info mb-3" />,
            title: "Prime Locations",
            desc: "Projects are developed in strategically selected locations with strong future growth potential."
        },
        {
            icon: <FaFileContract size={28} style={{ color: '#BD06D3' }} className="mb-3" />,
            title: "100% Legal Verification",
            desc: "Every project is backed by proper legal documentation, mutation, and transparent ownership."
        },
        {
            icon: <FaDraftingCompass size={28} className="text-info mb-3" />,
            title: "Quality Infrastructure",
            desc: "Well-planned wide roads, drainage system, electricity, and modern community amenities."
        },
        {
            icon: <FaChartLine size={28} style={{ color: '#BD06D3' }} className="mb-3" />,
            title: "Secure Investment",
            desc: "Projects designed to deliver high long-term appreciation and solid investment value."
        },
        {
            icon: <FaHandshake size={28} className="text-info mb-3" />,
            title: "Transparent Process",
            desc: "Zero hidden costs, clear communication, and honest business practices at every step."
        },
        {
            icon: <FaUserTie size={28} style={{ color: '#BD06D3' }} className="mb-3" />,
            title: "Professional Team",
            desc: "Experienced urban planners and legal experts dedicated from booking to final deed registration."
        },
        {
            icon: <FaHeadset size={28} className="text-info mb-3" />,
            title: "Dedicated Support",
            desc: "Prompt and responsive assistance before, during, and after your land purchase."
        },
        {
            icon: <FaLeaf size={28} style={{ color: '#BD06D3' }} className="mb-3" />,
            title: "Sustainable Development",
            desc: "Projects planned with eco-friendly infrastructure and environmental responsibility in mind."
        }
    ];

    // ২. Process Steps Data
    const processSteps = [
        { step: "01", title: "Land Selection", desc: "Careful strategic acquisition" },
        { step: "02", title: "Legal Verification", desc: "100% document clearance" },
        { step: "03", title: "Professional Dev.", desc: "Modern infrastructure plan" },
        { step: "04", title: "Transparent Booking", desc: "Hassle-free terms" },
        { step: "05", title: "Deed Registration", desc: "On-time legal transfer" },
        { step: "06", title: "Lifetime Support", desc: "Continuous client care" }
    ];

    // ৩. Customer Benefits Data
    const customerBenefits = [
        {
            icon: <FaCreditCard size={32} className="text-info" />,
            title: "Flexible Payment Plans",
            desc: "Affordable installment options designed to make land ownership easier for everyone."
        },
        {
            icon: <FaChartLine size={32} style={{ color: '#BD06D3' }} />,
            title: "High Appreciation Potential",
            desc: "Projects located in rapidly developing mega project zones with guaranteed return potential."
        },
        {
            icon: <FaShieldAlt size={32} className="text-info" />,
            title: "Peace of Mind",
            desc: "Legally secure land investments backed by expert guidance and complete transparency."
        },
        {
            icon: <FaHeart size={32} style={{ color: '#BD06D3' }} />,
            title: "Lifetime Trust",
            desc: "We build long-term relationships with our clients, going beyond simple real estate transactions."
        }
    ];

    return (
        <div className="bg-white overflow-hidden">
            {/* 1. Hero Banner */}
            <AboutBanner
                title="WHY CHOOSE US"
                description="Discover why hundreds of customers trust Iconic Greenland for secure, transparent, and value-driven land investments."
            />

            {/* 2. Intro Section (Text + Image) */}
            <section className=" pb-md-4 bg-white">
                <div className="container">
                    <div className="row g-4 g-lg-5 align-items-center">
                        <div className="col-lg-6">
                            <span className="text-info text-uppercase fw-bold tracking-wider small">
                                Building Trust, Securing Futures
                            </span>
                            <h2 className="fs-2 fw-bold text-dark mt-2 mb-3">
                                WHY CHOOSE <span style={{ color: '#BD06D3' }}>ICONIC GREENLAND</span>
                            </h2>
                            <p className="text-muted fs-6 leading-relaxed mb-4">
                                At Iconic Greenland, we believe that buying land is more than just an investment—it is a step toward building your future. Our commitment to transparency, legal assurance, quality development, and complete customer satisfaction makes us a trusted choice for residential and commercial plot investments.
                            </p>
                            <div className="d-flex flex-column gap-2">
                                <div className="d-flex align-items-center gap-2">
                                    <FaCheckCircle style={{ color: '#BD06D3' }} className="flex-shrink-0" />
                                    <span className="fw-semibold text-dark small fs-sm-6">100% Legally Clear & Verified Plots</span>
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                    <FaCheckCircle style={{ color: '#BD06D3' }} className="flex-shrink-0" />
                                    <span className="fw-semibold text-dark small fs-sm-6">Planned Eco-Friendly Smart Infrastructure</span>
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                    <FaCheckCircle style={{ color: '#BD06D3' }} className="flex-shrink-0" />
                                    <span className="fw-semibold text-dark small fs-sm-6">Client-Centric Transparent Transactions</span>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="rounded-4 overflow-hidden shadow-lg border">
                                <img
                                    src={whyChooseImg}
                                    alt="Why Choose Iconic Greenland"
                                    className="w-100 h-auto object-fit-cover"
                                    style={{ maxHeight: '420px', minHeight: '260px' }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* 3. Key Advantages (8 Icon Cards Grid) */}
            <section className="py-3 py-md-4 bg-light border-top border-bottom">
                <div className="container">
                    <div className="text-center max-w-2xl mx-auto mb-4 mb-md-5">
                        <span className="text-info text-uppercase fw-bold tracking-wider small">
                            Our Core Edge
                        </span>
                        <h2 className="fs-2 fw-bold text-dark mt-2">
                            KEY <span style={{ color: '#BD06D3' }}>ADVANTAGES</span>
                        </h2>
                        <p className="text-muted small fs-sm-6">The core reasons modern investors select Iconic Greenland for their property needs.</p>
                    </div>

                    <div className="row g-3 g-md-4">
                        {keyAdvantages.map((item, idx) => (
                            <div className="col-12 col-sm-6 col-lg-3" key={idx}>
                                <div className="card h-100 border-0 shadow-sm p-4 rounded-4 bg-white text-center hover-top transition">
                                    <div className="d-flex justify-content-center">{item.icon}</div>
                                    <h5 className="fw-bold text-dark mb-2 fs-6">{item.title}</h5>
                                    <p className="text-muted small mb-0">{item.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* 4. Our Commitment (Highlight Card) */}
            <section className="py-3 py-md-4 bg-white">
                <div className="container">
                    <div
                        className="p-4 p-md-5 rounded-4 shadow-sm border-start border-5 bg-light"
                        style={{ borderLeftColor: '#BD06D3' }}
                    >
                        <div className="row align-items-center">
                            <div className="col-lg-12">
                                <span className="text-info text-uppercase fw-bold tracking-wider small d-block mb-2">
                                    Our Uncompromising Standard
                                </span>
                                <h3 className="fw-bold text-dark mb-3 fs-4 fs-md-3">Our Commitment to You</h3>
                                <p className="text-muted fs-6 leading-relaxed mb-0">
                                    We are committed to delivering every project with integrity, professionalism, and complete transparency. From initial land acquisition and legal verification to final deed registration and handover, we ensure every customer enjoys a smooth, safe, and secure buying experience.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* 5. How We Make a Difference (Process Steps) */}
            <section className="py-3 py-md-4 bg-light border-top border-bottom">
                <div className="container">
                    <div className="text-center max-w-2xl mx-auto mb-4 mb-md-5">
                        <span className="text-info text-uppercase fw-bold tracking-wider small">Working Methodology</span>
                        <h2 className="fs-2 fw-bold text-dark mt-2">
                            HOW WE MAKE A <span style={{ color: '#BD06D3' }}>DIFFERENCE</span>
                        </h2>
                        <p className="text-muted small fs-sm-6">A step-by-step transparent journey from plot selection to ownership.</p>
                    </div>

                    <div className="row g-3 text-center">
                        {processSteps.map((p, idx) => (
                            <div className="col-6 col-sm-6 col-md-4 col-lg-2" key={idx}>
                                <div className="p-3 bg-white rounded-4 border shadow-sm h-100 position-relative d-flex flex-column justify-content-center align-items-center">
                                    <span
                                        className="badge rounded-pill mb-2 px-3 py-1"
                                        style={{ backgroundColor: idx % 2 === 0 ? '#00bfff' : '#BD06D3' }}
                                    >
                                        Step {p.step}
                                    </span>
                                    <h6 className="fw-bold text-dark mt-2 mb-1 fs-6">{p.title}</h6>
                                    <small className="text-muted d-block" style={{ fontSize: '12px' }}>{p.desc}</small>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* 6. Customer Benefits (4 Cards) */}
            <section className="py-3 py-md-4 bg-white">
                <div className="container">
                    <div className="text-center max-w-2xl mx-auto mb-4 mb-md-5">
                        <span className="text-info text-uppercase fw-bold tracking-wider small">Investor Value</span>
                        <h2 className="fs-2 fw-bold text-dark mt-2">
                            CUSTOMER <span style={{ color: '#BD06D3' }}>BENEFITS</span>
                        </h2>
                    </div>

                    <div className="row g-3 g-md-4">
                        {customerBenefits.map((b, idx) => (
                            <div className="col-12 col-md-6" key={idx}>
                                <div className="p-3 p-md-4 rounded-4 bg-light border h-100 d-flex gap-3 align-items-start">
                                    <div className="p-3 bg-white rounded-3 shadow-sm flex-shrink-0">
                                        {b.icon}
                                    </div>
                                    <div>
                                        <h5 className="fw-bold text-dark mb-2 fs-6">{b.title}</h5>
                                        <p className="text-muted small mb-0">{b.desc}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* 7. Statistics Section */}
            <section className="py-3 py-md-4 text-white" style={{ backgroundColor: '#00bfff' }}>
                <div className="container">
                    <div className="row g-4 text-center">
                        <div className="col-6 col-md-3">
                            <div className="d-flex justify-content-center align-items-center gap-2 mb-1">
                                <FaUsers size={24} />
                                <h2 className="fs-1 fw-bold text-white mb-0">500+</h2>
                            </div>
                            <p className="mb-0 opacity-90 fw-medium small">Happy Clients</p>
                        </div>
                        <div className="col-6 col-md-3">
                            <div className="d-flex justify-content-center align-items-center gap-2 mb-1">
                                <FaBuilding size={24} />
                                <h2 className="fs-1 fw-bold text-white mb-0">20+</h2>
                            </div>
                            <p className="mb-0 opacity-90 fw-medium small">Projects Undertaken</p>
                        </div>
                        <div className="col-6 col-md-3">
                            <div className="d-flex justify-content-center align-items-center gap-2 mb-1">
                                <FaChartLine size={24} />
                                <h2 className="fs-1 fw-bold text-white mb-0">1000+</h2>
                            </div>
                            <p className="mb-0 opacity-90 fw-medium small">Plots Sold</p>
                        </div>
                        <div className="col-6 col-md-3">
                            <div className="d-flex justify-content-center align-items-center gap-2 mb-1">
                                <FaCheckCircle size={24} />
                                <h2 className="fs-1 fw-bold text-white mb-0">98%</h2>
                            </div>
                            <p className="mb-0 opacity-90 fw-medium small">Customer Satisfaction</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Sister Concerns */}
            <div className="py-4">
                <SisterConcerms />
            </div>
        </div>
    );
};

export default WhyChooseUs;